module.exports = __webpack_public_path__ + "img/mission-image.ce48fd07.png";